import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TransactionComponent } from './components/transaction/transaction.component';
import { LoginComponent } from './components/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientXsrfModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgwWowModule } from 'ngx-wow';
import { AuthService } from './services/auth.service';
import { AuthGuardService } from './services/auth-guard.service';
import { DataService } from './services/data.service';
import { RequestIntercepterService } from './services/request-intercepter.service';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { CreateWorkItemComponent } from './components/create-work-item/create-work-item.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './shared/modules/material/material.module';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { ConfirmationDialogComponent } from './shared/components/confirmation-dialog/confirmation-dialog.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { LandingComponent } from './components/landing/landing.component';
import { AdvanceGridviewComponent } from './shared/components/advance-gridview/advance-gridview.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './shared/modules/material/shared.module';
import { DashboardLiteComponent } from './components/dashboard-lite/dashboard-lite.component';
import { UploadWorkItemComponent } from './components/upload-work-item/upload-work-item.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { ChangeDocumentTypeComponent } from './components/allocation/change-document-type/change-document-type.component';
import { ProxyComponent } from './components/allocation/proxy/proxy.component';
import { ManualComponent } from './components/allocation/manual/manual.component';
import { ChangeProcessComponent } from './components/allocation/change-process/change-process.component';
import { QCRuleBaseComponent } from './components/QCConfiguration/qcrulebase/qcrulebase.component';
import { TransactionLiteComponent } from './components/transaction-lite/transaction-lite.component';
import { MagnifyFieldSearchComponent } from './shared/components/magnify-field-search/magnify-field-search.component';
import { DoaFileUploadComponent } from './components/DOA/doa-file-upload/doa-file-upload.component';
import { OpensearchComponent } from './components/opensearch/opensearch.component';
import { EmailmanagerComponent } from './components/emailmanager/emailmanager.component';
import { NgxEditorModule } from 'ngx-editor';
import { DropdownMultiselectComponent } from './shared/components/dropdown-multiselect/dropdown-multiselect.component';
import { AutocompleteComponent } from './shared/components/autocomplete/autocomplete.component';
import { StandardGridviewComponent } from './shared/components/standard-gridview/standard-gridview.component';
import { WorkItemCloningComponent } from './components/allocation/work-item-cloning/work-item-cloning.component';
import { AdminSettingsComponent } from './components/admin-settings/admin-settings.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SafeHtmlPipe } from './pipes/safeHtml';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MsalModule, MsalService, MSAL_INSTANCE } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { QueryDashboardComponent } from './components/query-dashboard/query-dashboard.component';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import config from '../assets/config.json';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { UploadWorkItemBsemComponent } from './components/upload-work-item-bsem/upload-work-item-bsem.component';
import { CommonService } from './services/common.service';
import { UserlistComponent } from './components/userlist/userlist.component';
import { UnlockInvoiceComponent } from './components/unlock-invoice/unlock-invoice.component';
import { UserdetailsComponent } from './components/userdetails/userdetails.component';
import { NgIdleService } from './services/ng-idle.service';
// import { NgxMaskModule } from 'ngx-mask';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { ReportComponent } from './components/report/report.component';
import { HelpSectionComponent } from './components/help-section/help-section.component';
import { HelpSectionDetailsComponent } from './components/help-section-details/help-section-details.component';
import { UpdateDataComponent } from './components/update-data/update-data.component';
import { Ibos360DashboardInfographicalComponent } from './components/ibos360-dashboard-infographical/ibos360-dashboard-infographical.component';
import { InactiveUserReallocationComponent } from './components/inactive-user-reallocation/inactive-user-reallocation.component';
import { CreateDoaRuleComponent } from './components/create-doa-rule/create-doa-rule.component';
import { CreateDoaImportComponent } from './components/create-doa-import/create-doa-import.component';
import { CreateDOAConfigComponent } from './components/create-doa-config/create-doa-config.component';
import { CreateDoaApprovalComponent } from './components/create-doa-approval/create-doa-approval.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { CreateDoaFilterComponent } from './components/create-doa-filter/create-doa-filter.component';
import { UnitwiseDashboardComponent } from './components/unitwise-dashboard/unitwise-dashboard.component';
import { WorkflowStatusComponent } from './components/unitwise-dashboard/workflow-status/workflow-status.component';
import { DebouncedSearchFieldComponent } from './shared/components/debounced-search-field/debounced-search-field.component';
import { ChartDashboardComponent } from './components/chart-dashboard/chart-dashboard.component';
import { ControlPanelComponent } from './components/control-panel/control-panel.component';
import { UploadLogoImageComponent } from './components/upload-logo-image/upload-logo-image.component';
import { ControlPanelLiteComponent } from './components/control-panel-lite/control-panel-lite.component';
import { SSOLoginComponent } from './components/ssologin/ssologin.component';
import { CookiPolicyComponent } from './components/cooki-policy/cooki-policy.component';
import { MatDialog } from '@angular/material/dialog';
// import{CookieService} from 'ngx-cookie-service';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LandingComponent,
    DashboardComponent,
    DashboardLiteComponent,
    TransactionComponent,
    CreateWorkItemComponent,
    LoginComponent,
    BreadcrumbComponent,
    NumberOnlyDirective,
    LoaderComponent,
    ConfirmationDialogComponent,
    AdvanceGridviewComponent,
    UploadWorkItemComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ChangeDocumentTypeComponent,
    ProxyComponent,
    ManualComponent,
    ChangeProcessComponent,
    QCRuleBaseComponent,
    TransactionLiteComponent,
    MagnifyFieldSearchComponent,
    DoaFileUploadComponent,
    OpensearchComponent,
    EmailmanagerComponent,
    DropdownMultiselectComponent,
    AutocompleteComponent,
    AdminSettingsComponent,
    StandardGridviewComponent,
    WorkItemCloningComponent,
    QueryDashboardComponent,
    SafeHtmlPipe,
    UploadWorkItemBsemComponent,
    UserlistComponent,
    UnlockInvoiceComponent,
    UserdetailsComponent,
    UploadFileComponent,
    ReportComponent,
    HelpSectionComponent,
    HelpSectionDetailsComponent,
    UpdateDataComponent,
    Ibos360DashboardInfographicalComponent,
    InactiveUserReallocationComponent,
    CreateDoaRuleComponent,
    CreateDoaImportComponent,
    CreateDOAConfigComponent,
    CreateDoaApprovalComponent,
    FeedbackComponent,
    CreateDoaFilterComponent,
    UnitwiseDashboardComponent,
    WorkflowStatusComponent,
    DebouncedSearchFieldComponent,
    ChartDashboardComponent,
    ControlPanelComponent,
    UploadLogoImageComponent,
    ControlPanelLiteComponent,
    SSOLoginComponent,
    CookiPolicyComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'XSRF-TOKEN',
      headerName: 'X-XSRF-TOKEN',
    }),
    NgwWowModule,
    BrowserAnimationsModule,
    MaterialModule,
    NgbModule,
    SharedModule,
    NgxEditorModule,
    AngularEditorModule,
    MatTooltipModule,
    // PdfViewerModule,
    // NgxMaskModule.forRoot(),
    NgxDatatableModule
  ],
  // providers: [CookieService,CommonService, DataService, AuthService, AuthGuardService, RequestIntercepterService,
  //   {
  providers: [CommonService, DataService, AuthService, AuthGuardService, RequestIntercepterService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestIntercepterService,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MASALInstanceFactory
    },
    MsalService,
    NgIdleService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  clientId: string = config.azure_clientId;
  redirectUri: string = config.azure_redirectUri;
  authority: string = config.azure_authority;

  constructor(private dataService: DataService, private _http: HttpClient) {
    this.getConfigData();
  }
  getConfigData() {
    fetch('./assets/config.json').then(res => res.json())
      .then(data => {
        this.clientId = data.azure_clientId;
        this.redirectUri = data.azure_redirectUri;
        this.authority = data.azure_authority;
        //console.log('config => ', data);
      });
  }
}
export function MASALInstanceFactory(): IPublicClientApplication {

  return new PublicClientApplication({

    auth: {
      clientId: config.azure_clientId,
      redirectUri: config.azure_redirectUri,
      authority: config.azure_authority
    }


  })

}
